import { useRef } from 'react';

export const useDebounce = (action) => {

    const debounceRef = useRef();

    const onQueryChanged = (e) => {
        if(debounceRef?.current)
            clearTimeout(debounceRef?.current);

        debounceRef.current = setTimeout(() => {
            action(e?.target?.value);
        }, 500);
    }

    return {
        onQueryChanged
    }
}